var _style, _defs, _rect, _path, _path2, _rect2, _rect3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect4, _rect5, _rect6, _path10, _rect7, _path11, _path12, _path13, _rect8, _path14, _path15, _path16, _path17, _rect9, _path18, _rect10, _rect11, _path19, _path20, _path21, _rect12, _path22, _path23, _path24, _path25, _rect13, _rect14, _rect15, _rect16, _path26, _rect17, _path27, _path28, _rect18, _rect19, _rect20, _path29, _rect21, _rect22, _rect23, _path30, _path31, _rect24, _rect25, _path32, _rect26, _rect27, _path33, _path34, _path35, _path36, _path37, _rect28, _path38, _path39, _path40, _rect29, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _rect30, _rect31, _rect32, _path48, _rect33, _path49, _path50, _path51, _path52, _path53, _rect34, _path54, _path55, _path56, _path57, _path58, _rect35, _path59, _rect36, _rect37, _rect38, _rect39, _path60, _path61, _path62, _rect40, _path63, _path64, _rect41, _path65, _path66, _path67, _path68, _rect42, _path69, _path70, _path71, _rect43, _path72, _path73, _path74, _path75, _rect44, _path76, _rect45, _path77, _rect46, _path78, _path79, _path80, _rect47, _path81, _path82, _rect48, _path83, _path84, _path85, _rect49, _rect50, _rect51, _path86, _path87, _rect52, _path88, _rect53, _path89, _path90, _path91, _path92, _rect54, _path93, _path94, _rect55, _rect56, _path95, _path96, _path97, _rect57, _path98, _path99, _path100, _path101, _rect58, _rect59, _path102, _path103, _path104, _rect60, _rect61, _path105, _rect62, _path106, _rect63, _rect64, _rect65, _path107, _path108, _rect66, _path109, _rect67, _path110, _path111, _rect68, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _rect69, _path122, _path123, _path124, _rect70, _path125, _rect71, _path126, _rect72, _path127, _rect73, _rect74, _rect75, _rect76, _path128, _path129, _rect77, _path130, _path131, _path132, _rect78, _rect79, _rect80, _path133, _path134, _path135, _path136, _path137, _path138, _rect81, _path139, _path140, _path141, _path142, _rect82, _rect83, _rect84, _rect85, _path143, _path144, _rect86, _rect87, _path145, _path146, _path147, _rect88, _rect89, _rect90, _path148, _path149, _path150, _path151, _rect91, _rect92, _rect93, _path152, _path153, _path154, _rect94, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _rect95, _rect96, _path162, _path163, _rect97, _path164, _path165, _rect98, _path166, _rect99, _path167, _rect100, _path168, _path169, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _path170, _path171, _rect108, _path172, _rect109, _path173, _rect110, _path174, _path175, _rect111, _path176, _path177, _path178, _path179, _rect112, _path180, _path181, _path182, _path183, _path184, _path185, _rect113, _path186, _rect114, _path187, _rect115, _rect116, _path188, _path189, _path190, _path191, _rect117, _rect118, _path192, _path193, _rect119, _rect120, _path194, _path195, _rect121, _path196, _path197, _rect122, _path198, _rect123, _rect124, _path199, _path200, _rect125, _path201, _path202, _path203, _rect126, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "frame-top-frame",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.1 355.1",
    style: {
      enableBackground: "new 0 0 279.1 355.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.frame-color{fill:#000000;}\n\t.background-color{fill:#ffffff;}\n\t.text-color{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 259.8,
    height: 259.8,
    viewBox: "0 0 2000 2000",
    x: 9.7,
    y: 9.6,
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 200,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 200,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 200,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 200,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 264,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 264,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 264,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 264,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 328,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 392,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 456,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 520,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 584,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 648,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 200,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 264,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 328,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 392,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 584,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 712,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 200,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 264,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 328,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 328,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 392,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 520,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 648,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 776,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 200,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 264,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 392,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 456,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 520,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 584,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 840,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 200,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 264,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 328,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 392,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 456,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 520,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 904,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 200,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 264,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 328,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 584,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 968,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 200,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 264,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 328,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 456,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 520,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 584,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 648,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1032,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 264,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 392,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 456,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 520,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 584,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1096,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 200,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 392,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 456,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 520,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 584,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 648,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1160,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 392,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 584,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 648,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1224,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 648,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1288,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1352,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1416,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1480,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1416,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1544,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 776,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 904,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1224,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1608,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 840,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1032,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1288,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1352,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1480,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1544,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1672,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 712,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 968,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1096,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1160,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1608,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1672,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1736,
    y: 1736,
    width: 64,
    height: 64,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 200,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 200,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1352,
    y: 200,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1352,
    y: 200,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 1352,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 200,
    y: 1352,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 448,
    height: 448,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  })))), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "FrameBody",
    className: "frame-color",
    d: "M265.4,0H13.7C6.1,0,0,6.1,0,13.7v251.6c0,7.6,6.2,13.7,13.7,13.7h251.6c7.6,0,13.7-6.1,13.8-13.6V13.7 C279.1,6.1,272.9,0,265.4,0z M268.5,261.1c0,4.1-3.3,7.4-7.4,7.4H17.9c-4.1,0-7.4-3.3-7.4-7.4V17.9c0-4.1,3.3-7.4,7.4-7.4h243.2 c4.1,0,7.4,3.3,7.4,7.4V261.1z"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "TextArea",
    x: 0,
    y: 275,
    width: 279,
    height: 90,
    viewBox: "0 0 119.55517578125 17.588541666667",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "text-color",
    fill: "#FFFFFF",
    d: " M8.314453125,13.19140625l-4.38818359375,0l0-7.8525390625l4.38818359375,0l0,0.8701171875l-3.39990234375,0l0,2.44921875l3.201171875,0l0,0.859375l-3.201171875,0l0,2.8037109375l3.39990234375,0l0,0.8701171875z M14.49658203125,11.09130859375q0,1.02587890625-0.7412109375,1.61669921875t-2.0625,0.5908203125q-1.396484375,0-2.1591796875-0.37060546875l0-0.9453125q0.49951171875,0.21484375,1.093017578125,0.33837890625t1.109130859375,0.12353515625q0.880859375,0,1.32666015625-0.33837890625t0.44580078125-0.92919921875q0-0.39208984375-0.1611328125-0.64453125t-0.539794921875-0.47265625t-1.146728515625-0.49951171875q-1.09033203125-0.3974609375-1.5576171875-0.937255859375t-0.46728515625-1.393798828125q0-0.91845703125,0.690185546875-1.4609375t1.818115234375-0.54248046875q1.17626953125,0,2.16455078125,0.4404296875l-0.30615234375,0.8486328125q-1.009765625-0.4189453125-1.8798828125-0.4189453125q-0.6982421875,0-1.093017578125,0.30078125t-0.394775390625,0.84326171875q0,0.38671875,0.153076171875,0.641845703125t0.494140625,0.464599609375t1.071533203125,0.47802734375q0.87548828125,0.322265625,1.30517578125,0.625732421875t0.6337890625,0.6982421875t0.2041015625,0.942626953125z M19.443359375,6.09619140625q-1.267578125,0-1.99267578125,0.8486328125t-0.72509765625,2.3203125q0,1.52001953125,0.70361328125,2.344482421875t2.00341796875,0.824462890625q0.837890625,0,1.88525390625-0.3115234375l0,0.859375q-0.49951171875,0.1826171875-0.96142578125,0.249755859375t-1.0634765625,0.067138671875q-1.73486328125,0-2.672119140625-1.055419921875t-0.937255859375-2.989013671875q0-1.2138671875,0.448486328125-2.126953125t1.30517578125-1.4072265625t2.016845703125-0.494140625q1.24609375,0,2.169921875,0.4619140625l-0.3974609375,0.837890625q-0.93994140625-0.4296875-1.783203125-0.4296875z M27.95654296875,13.19140625l-0.9453125-2.43310546875l-3.115234375,0l-0.9345703125,2.43310546875l-0.9990234375,0l3.06689453125-7.884765625l0.8916015625,0l3.0615234375,7.884765625l-1.02587890625,0z M26.7158203125,9.8828125l-0.880859375-2.37939453125l-0.3759765625-1.17626953125q-0.1611328125,0.64453125-0.33837890625,1.17626953125l-0.8916015625,2.37939453125l2.48681640625,0z M36.287109375,13.19140625l-1.15478515625,0l-4.20556640625-6.5205078125l-0.04296875,0l0.02685546875,0.43505859375q0.064453125,0.9775390625,0.064453125,1.697265625l0,4.38818359375l-0.9130859375,0l0-7.8525390625l1.14404296875,0l0.24169921875,0.38134765625l2.578125,3.9853515625l1.36962890625,2.13232421875l0.04296875,0q-0.0107421875-0.12890625-0.04296875-0.921142578125t-0.0322265625-1.146728515625l0-4.43115234375l0.923828125,0l0,7.8525390625z M42.8076171875,13.19140625l-4.38818359375,0l0-7.8525390625l4.38818359375,0l0,0.8701171875l-3.39990234375,0l0,2.44921875l3.201171875,0l0,0.859375l-3.201171875,0l0,2.8037109375l3.39990234375,0l0,0.8701171875z M49.46240234375,13.19140625l-0.9453125-2.43310546875l-3.115234375,0l-0.9345703125,2.43310546875l-0.9990234375,0l3.06689453125-7.884765625l0.8916015625,0l3.0615234375,7.884765625l-1.02587890625,0z M48.2216796875,9.8828125l-0.880859375-2.37939453125l-0.3759765625-1.17626953125q-0.1611328125,0.64453125-0.33837890625,1.17626953125l-0.8916015625,2.37939453125l2.48681640625,0z  M59.45263671875,7.6484375q0,1.203125-0.82177734375,1.844970703125t-2.31494140625,0.641845703125l-0.90234375,0l0,3.05615234375l-0.98828125,0l0-7.8525390625l2.07861328125,0q2.94873046875,0,2.94873046875,2.3095703125z M55.41357421875,9.28662109375l0.78955078125,0q1.1708984375,0,1.697265625-0.378662109375t0.5263671875-1.216552734375q0-0.75732421875-0.48876953125-1.13330078125t-1.525390625-0.3759765625l-0.9990234375,0l0,3.1044921875z M66.00537109375,13.19140625l-0.9453125-2.43310546875l-3.115234375,0l-0.9345703125,2.43310546875l-0.9990234375,0l3.06689453125-7.884765625l0.8916015625,0l3.0615234375,7.884765625l-1.02587890625,0z M64.7646484375,9.8828125l-0.880859375-2.37939453125l-0.3759765625-1.17626953125q-0.1611328125,0.64453125-0.33837890625,1.17626953125l-0.8916015625,2.37939453125l2.48681640625,0z M69.09912109375,9.109375l1.17626953125,0q0.9560546875,0,1.396484375-0.3759765625t0.4404296875-1.1171875t-0.44580078125-1.082275390625t-1.44482421875-0.341064453125l-1.12255859375,0l0,2.91650390625z M69.09912109375,9.947265625l0,3.244140625l-0.98828125,0l0-7.8525390625l2.16455078125,0q1.4609375,0,2.161865234375,0.555908203125t0.700927734375,1.673095703125q0,1.56298828125-1.57373046875,2.10546875l2.15380859375,3.51806640625l-1.15478515625,0l-1.9013671875-3.244140625l-1.56298828125,0z M79.87890625,13.19140625l-0.9453125-2.43310546875l-3.115234375,0l-0.9345703125,2.43310546875l-0.9990234375,0l3.06689453125-7.884765625l0.8916015625,0l3.0615234375,7.884765625l-1.02587890625,0z M78.63818359375,9.8828125l-0.880859375-2.37939453125l-0.3759765625-1.17626953125q-0.1611328125,0.64453125-0.33837890625,1.17626953125l-0.8916015625,2.37939453125l2.48681640625,0z  M83.72998046875,15.28076171875q-0.5048828125,0-0.81640625-0.14501953125l0-0.83251953125q0.38134765625,0.107421875,0.794921875,0.107421875q0.537109375,0,0.8056640625-0.324951171875t0.2685546875-0.937255859375l0-7.8095703125l0.99365234375,0l0,7.72900390625q0,1.0634765625-0.529052734375,1.63818359375t-1.517333984375,0.57470703125z M93.81689453125,5.3388671875l0,5.0810546875q0,1.3427734375-0.81103515625,2.11083984375t-2.25048828125,0.76806640625q-1.42333984375,0-2.20751953125-0.776123046875t-0.7841796875-2.124267578125l0-5.0595703125l0.99365234375,0l0,5.091796875q0,0.96142578125,0.512939453125,1.48779296875t1.544189453125,0.5263671875q0.97216796875,0,1.495849609375-0.52099609375t0.523681640625-1.50390625l0-5.0810546875l0.98291015625,0z M99.29541015625,9.044921875l2.71240234375,0l0,3.85107421875q-0.623046875,0.19873046875-1.267578125,0.30078125t-1.4931640625,0.10205078125q-1.7939453125,0-2.77685546875-1.0634765625t-0.98291015625-2.97021484375q0-1.22998046875,0.48876953125-2.1484375t1.409912109375-1.404541015625t2.172607421875-0.486083984375q1.2568359375,0,2.341796875,0.4619140625l-0.3759765625,0.859375q-1.03662109375-0.451171875-2.02490234375-0.451171875q-1.40185546875,0-2.19140625,0.8486328125t-0.78955078125,2.3203125q0,1.5576171875,0.75732421875,2.36865234375t2.2021484375,0.81103515625q0.78955078125,0,1.54150390625-0.18798828125l0-2.3310546875l-1.72412109375,0l0-0.880859375z M108.818359375,13.19140625l-0.9453125-2.43310546875l-3.115234375,0l-0.9345703125,2.43310546875l-0.9990234375,0l3.06689453125-7.884765625l0.8916015625,0l3.0615234375,7.884765625l-1.02587890625,0z M107.57763671875,9.8828125l-0.880859375-2.37939453125l-0.3759765625-1.17626953125q-0.1611328125,0.64453125-0.33837890625,1.17626953125l-0.8916015625,2.37939453125l2.48681640625,0z M111.912109375,9.109375l1.17626953125,0q0.9560546875,0,1.396484375-0.3759765625t0.4404296875-1.1171875t-0.44580078125-1.082275390625t-1.44482421875-0.341064453125l-1.12255859375,0l0,2.91650390625z M111.912109375,9.947265625l0,3.244140625l-0.98828125,0l0-7.8525390625l2.16455078125,0q1.4609375,0,2.161865234375,0.555908203125t0.700927734375,1.673095703125q0,1.56298828125-1.57373046875,2.10546875l2.15380859375,3.51806640625l-1.15478515625,0l-1.9013671875-3.244140625l-1.56298828125,0z "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.157be3f5b58aea4eca6befff7136d0ac.svg";
export { ForwardRef as ReactComponent };